module.exports = __webpack_public_path__ + "img/pasos-de-uso-3.92a85d97.svg";